module.exports = require("./es-ES.js");